import React from 'react';
import { Picker, List } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { GoodsShoppingCart } from 'src/common/goods-shopping-cart/GoodsShoppingCart';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsFavorites.less';

export default class GoodsFavorites extends OfficialPage {
  state = {
    topNavBarData: {
      title: '收藏夹',
      isDefault: 0
    },
    favoritesStatus: [
      { label: '全部', value: 0 },
      { label: '失效', value: 2 },
      { label: '降价中', value: 3 },
      { label: '低库存', value: 4 }
    ],
    selectAll: false,
    showCheckedBox: false,
    favoritesList: [],
    selectStatus: [0],
    unSaleGoodsCount: 0,
    reducePriceGoodsNum: 0,
    hideTips: false,
    showReducePrice: true,
    search: '',
    storeStyle: {}
  }
  page = 1
  isMore = 1

  goodsShoppingCartRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '收藏夹';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.dataInitial()
  }

  componentDidMount() { }

  dataInitial = () => {
    this.getFavoriteGoodsList()
    this.getAppECStoreConfig()
  }
  getFavoriteGoodsList = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/favoriteGoodsList',
      data: {
        page: _this.page,
        page_size: 10,
        status: _this.data.selectStatus[0],
        search: _this.data.search,
        parent_app_id: 
          app.getShopTypeData() && app.getShopTypeData().is_parent_shop == 1
            ? app.getAppId()
            : '' // 总店要把子店商品展示
      },
      success: function (res) {
        _this.setData({
          favoritesList: _this.data.favoritesList.concat(res.data),
          unSaleGoodsCount: res.un_sale_goods_count || 0,
          reducePriceGoodsNum: res.reduce_price_goods_num || 0
        })
        _this.isMore = res.is_more
      }
    })
  }
  addShoppingCart = event => {
    event.stopPropagation()
    this.goodsShoppingCartRef.current.showDialog({
      goodsId: event.currentTarget.dataset.id
    });
  }
  selectGoods = event => {
    let index = event.currentTarget.dataset.index
    let favoritesList = this.data.favoritesList
    let selectAll = true
    favoritesList[index].selected = !favoritesList[index].selected
    favoritesList.map(item => {
      if (!item.selected) selectAll = false
    })
    this.setData({
      favoritesList: favoritesList,
      selectAll: selectAll
    })
  }
  clickSelectAll = () => {
    let _this = this
    let selectAll = this.data.selectAll
    let favoritesList = this.data.favoritesList
    favoritesList.map(item => {
      item.selected = !selectAll
    })
    this.setData({
      favoritesList: favoritesList,
      selectAll: !selectAll
    })
  }
  onReachBottom = () => {
    if (!this.isMore) {
      return
    }
    this.page++
    this.getFavoriteGoodsList()
  }
  selectFavoritesStatus = value => {
    this.setData({
      favoritesList: [],
      selectStatus: value
    })
    this.page = 1
    this.getFavoriteGoodsList()
  }
  searchFavoritesGoods = event => {
    if (event.keyCode !== 13) {
      return;
    }
    this.page = 1
    this.setData({
      search: event.target.value,
      favoritesList: []
    })
    this.getFavoriteGoodsList()
  }
  deleteGoods = () => {
    let _this = this
    let deleteIdArr = []
    let favoritesList = this.data.favoritesList
    for (let i = 0; i < favoritesList.length; i++) {
      if (favoritesList[i].selected) {
        deleteIdArr.push(favoritesList[i].id)
        favoritesList.splice(i, 1)
        i--
      }
    }
    if (deleteIdArr.length <= 0) {
      app.showToast({ title: '未选择商品', icon: 'none' });
      return;
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteFavoriteGoods',
      method: 'post',
      data: {
        goods_id_arr: deleteIdArr
      },
      success: function (res) {
        _this.setData({
          favoritesList: favoritesList,
          showCheckedBox: false
        })
      }
    })
  }
  favoritesOperat = () => {
    this.setData({
      showCheckedBox: true
    })
  }
  favoritesComplete = () => {
    this.setData({
      showCheckedBox: false
    })
  }
  cleanUpGoods = () => {
    this.setData({
      selectStatus: 1,
      favoritesList: []
    })
    this.page = 1
    this.getFavoriteGoodsList()
  }
  hideTips = () => {
    this.setData({
      hideTips: true
    })
  }
  goHomePage = () => {
    let router = app.getHomepageRouter()
    app.reLaunch({ url: '/pages/' + router + '/' + router })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    })
  }
  checkReducePrice = () => {
    this.setData({
      selectStatus: 2,
      showReducePrice: false,
      favoritesList: []
    })
    this.page = 1
    this.getFavoriteGoodsList()
  }
  hideReducePrice = () => {
    this.setData({
      showReducePrice: false
    })
  }
  goGoodsDetail = event => {
    app.turnToPage(
      '/pages/goodsDetail/goodsDetail?detail=' + event.currentTarget.dataset.id
    )
  }

  render() {
    const {
      showGetUserInfo,
      topNavBarData,
      storeStyle,
      favoritesList,
      selectStatus,
      search,
      hideTips,
      unSaleGoodsCount,
      favoritesStatus,
      showCheckedBox,
      selectAll,
      showReducePrice,
      reducePriceGoodsNum
    } = this.state

    return (
      <div className="official-page goods-favorites">
        <TopNav title="收藏夹" />
        {!favoritesList.length && selectStatus == 0 && !search ? (
          <React.Fragment>
            <div className="no-favorites-goods">
              <span className="ico-moon icon-favorites"></span>
              <div className="no-favorites-title">您暂时还未收藏商品</div>
              <div
                className="no-favorites-btn"
                style={convertLineStyleData('background:' + storeStyle.theme)}
                onClick={this.goHomePage}
              >
                去逛逛
              </div>
            </div>
          </React.Fragment>
        ) : (
            <React.Fragment>
              <div
                className="invalid-tips"
                hidden={hideTips || !unSaleGoodsCount}
              >
                <span
                  className="ico-moon icon-closes"
                  onClick={this.hideTips}
                ></span>
                <span>{'失效宝贝（' + unSaleGoodsCount + '个）'}</span>
                <span
                  className="pull-right go-invalid-goods"
                  onClick={this.cleanUpGoods}
                >
                  前往清理
              </span>
              </div>
              <div>
                <div className="favorites-header">
                  <div className="favorites-status-select">
                    <Picker
                      cols={1}
                      data={favoritesStatus}
                      onChange={this.selectFavoritesStatus}
                      value={selectStatus}
                    >
                      <List.Item></List.Item>
                    </Picker>
                    <span className="ico-moon icon-downarrow"></span>
                  </div>
                  <div className="favorites-search">
                    <span className="ico-moon icon-search"></span>
                    <input
                      type="text"
                      onKeyDown={this.searchFavoritesGoods}
                      placeholder="请输入搜索内容"
                    />
                  </div>
                  {!showCheckedBox ? (
                    <span
                      className="favorites-operat"
                      onClick={this.favoritesOperat}
                    >
                      管理
                  </span>
                  ) : (
                      <span
                        className="favorites-operat"
                        onClick={this.favoritesComplete}
                      >
                        完成
                  </span>
                    )}
                </div>
                <div className="favorites-content">
                  {favoritesList.map((item, index) => {
                    return (
                      <div
                        className="goods-list"
                        key={item.id}
                        onClick={
                          item.status != 1 && !showCheckedBox
                            ? this.goGoodsDetail
                            : null
                        }
                        data-id={item.id}
                      >
                        {showCheckedBox && (
                          <label
                            className={
                              'favorites-check-box ' +
                              (item.selected
                                ? 'checked ico-moon icon-success-tip'
                                : '')
                            }
                            style={convertLineStyleData('color:' + storeStyle.theme)}
                            onClick={this.selectGoods}
                            data-index={index}
                          ></label>
                        )}
                        <img src={item.cover} />
                        <div className="goods-detail-box">
                          <div className="goods-title">{item.title}</div>
                          <div className="collect-number">
                            {item.favorite_people_num + '人收藏'}
                          </div>
                          {(item.reduce_price > 0 || item.stock <= 20) && (
                            <div>
                              {item.reduce_price > 0 && (
                                <span
                                  className="goods-reduce-price"
                                  style={convertLineStyleData(
                                    'color:' +
                                    storeStyle.theme +
                                    ';background:' +
                                    storeStyle.theme +
                                    '19'
                                  )}
                                >
                                  {'比收藏时降价' + item.reduce_price + '元'}
                                </span>
                              )}
                              {item.stock <= 20 && (
                                <span className="almost-stock">库存紧张</span>
                              )}
                            </div>
                          )}
                          {item.status == 1 ? (
                            <div className="goods-price-box">
                              <span className="goods-invalid">失效</span>
                            </div>
                          ) : (
                              <div className="goods-price-box">
                                <span
                                  className="goods-price"
                                  style={convertLineStyleData('color:' + storeStyle.theme)}
                                >
                                  {'¥' + item.price}
                                </span>
                                <span
                                  className="pull-right ico-moon icon-addshoppingcart3"
                                  style={convertLineStyleData('color:' + storeStyle.theme)}
                                  data-id={item.id}
                                  onClick={showCheckedBox ? null : this.addShoppingCart}
                                ></span>
                              </div>
                            )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              {showCheckedBox && (
                <div className="favorites-bottom">
                  <div className="select-all">
                    <label
                      className={
                        'favorites-check-box ' +
                        (selectAll ? 'checked ico-moon icon-success-tip' : '')
                      }
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                      onClick={this.clickSelectAll}
                    ></label>
                    <span>全选</span>
                  </div>
                  <div
                    className="pull-right delete-goods"
                    style={convertLineStyleData('background:' + storeStyle.theme)}
                    onClick={this.deleteGoods}
                  >
                    一键删除
                </div>
                </div>
              )}
            </React.Fragment>
          )}
        {showReducePrice && reducePriceGoodsNum > 0 && (
          <div className="reduce-price-mask">
            <div className="reduce-price-contain">
              <div className="reduce-title">商品降价啦</div>
              <div className="reduce-content">您收藏的商品降价啦</div>
              <div className="reduce-content">快去瞧瞧吧</div>
              <div
                className="check-reduce-price"
                onClick={this.checkReducePrice}
              >
                立即查看
              </div>
              <div
                className="wait-reduce-price"
                onClick={this.hideReducePrice}
              >
                稍后查看
              </div>
            </div>
          </div>
        )}
        <GoodsShoppingCart ref={this.goodsShoppingCartRef} />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/official-page/goods-favorites/GoodsFavorites.jsx